<template>
    <small-dialog
        @ok="create"
        v-model="dialog"
        title="Buat link"
        okButton="buat"
        :okDisabled="! valid"
    >
        <template #activator="{ on }">
            <v-btn v-on="on" text>
                <v-icon left>mdi-link-plus</v-icon>
                link
            </v-btn>
        </template>

        <v-form @submit.prevent="create" v-model="valid" ref="form">
            <v-text-field
                v-model="link"
                autofocus
                label="Link"
                prepend-icon="mdi-link"
                :rules="rules.link"
            ></v-text-field>

            <v-text-field
                v-model="text"
                label="Teks"
                prepend-icon="mdi-format-text"
                :rules="rules.text"
            ></v-text-field>
        </v-form>
    </small-dialog>
</template>

<script>
import SmallDialog from '@/components/dialog/SmallDialog'

export default {
    components: {
        SmallDialog,
    },

    data: () => ({
        dialog: false,
        valid: false,
        link: null,
        text: null,
        rules: {
            link: [
                v => !!v || 'Link harus diisi',
                v => (!!v && /^((https?|ftp|file):\/\/)([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/.test(v))
                    || 'Link tidak valid'
            ],
            text: [
                v => !!v || 'Teks harus diisi'
            ]
        }
    }),

    methods: {
        create() {
            this.$emit('create', `<a href="${this.link}">${this.text}</a>`)
            this.$refs.form.reset()
            this.dialog = false
        }
    }
}
</script>
